import React, { useEffect, useState } from 'react';
import UpdatePage from '../_component/Live/UpdatePage';
import { ISupportLanguage } from 'utils/types/storyTypes';
import { useParams } from 'react-router-dom';
import { IMinicut } from 'utils/types/resourceTypes';
import { storyApi } from 'apis/story/storyApis';
import { useAppDispatch } from 'hooks/redux';
import { setEditName, setStoryName } from 'store/slices/breadcumbSlice';
import { useCookies } from 'react-cookie';
import { handleMessage } from 'utils/helper/message';
import { message } from 'antd';
import { liveIllustApi } from 'apis/resource/liveIllustApis';

export default function LiveIllustUpdate() {
  const dispatch = useAppDispatch();
  const [cookies] = useCookies();
  const { projectId, liveId } = useParams();
  const [data, setData] = useState<IMinicut | null>(null);
  const [supportLangList, setSupportLangList] = useState<
    ISupportLanguage[] | null
  >(null);

  const handleFetchData = async () => {
    if (projectId) {
      try {
        const storyDetailData = await storyApi.storyDetail(projectId);
        const liveDataRes = await liveIllustApi.liveIllustList(projectId);
        const detailLiveData = liveDataRes.list.find(
          (e) => e.id === Number(liveId),
        );
        const langRes = await storyApi.supportLang();
        setData(detailLiveData);
        setSupportLangList(langRes);
        dispatch(setEditName(detailLiveData.live_name));

        const episodeName = storyDetailData?.project?.projectDetails?.find(
          (e) => e.lang === cookies.lang,
        );
        dispatch(
          setStoryName(episodeName ? episodeName.title : storyDetailData.title),
        );
      } catch (err) {
        handleMessage(message, 'error', 'Call api error');
      }
    }
  };

  useEffect(() => {
    handleFetchData();
  }, []);
  return (
    <UpdatePage
      type='live_illust'
      data={data}
      setData={setData}
      supportLangList={supportLangList}
    />
  );
}
